import React from 'react';
import PageSyle from '../style';
import NextBackNav from '../../../components/nextBackNav';
import RoundScreen from '../../../components/roundScreen';
import MultiHalfText from '../../../components/MultiHalfText';

export default function Page01({nextPressed, backPressed, nextSlideExzists, previousSlideExzists}) {
	let style = PageSyle();
	return (
		<div style={style.outerStyle()}>
			<MultiHalfText first='HIIT / Plyometrics' second='Workout 06' mt={true} />
			<RoundScreen
				isNumbered={false}
				rounds={[
					[
						{
							header: 'FULLBODY / HIT',
							value: 'Burpees',
						},
						{
							header: 'REPS',
							value: '10',
						},
					],
					[
						{
							header: 'FULLBODY / HIT',
							value: 'Knee Strikes',
						},
						{
							header: 'REPS',
							value: '15',
						},
					],
					[
						{
							header: 'FULLBODY / HIT',
							value: 'Squat to Press w / (DB)',
						},
						{
							header: 'REPS',
							value: '12',
						},
					],
					[
						{
							header: 'FULLBODY / HIT',
							value: 'Touchdown Lunges',
						},
						{
							header: 'REPS',
							value: '12',
						},
					],
					[
						{
							header: 'FULLBODY / HIT',
							value: 'Snatches w / (DB)',
						},
						{
							header: 'REPS',
							value: '10',
						},
					],
				]}
			/>
			<NextBackNav
				message='Ready to continue?'
				mt={true}
				nextPressed={nextPressed}
				backPressed={backPressed}
				nextSlideExzists={nextSlideExzists}
				previousSlideExzists={previousSlideExzists}
			/>
		</div>
	);
}
